import { render, staticRenderFns } from "./CatalogChange.vue?vue&type=template&id=306b6f60&"
import script from "./CatalogChange.vue?vue&type=script&lang=ts&"
export * from "./CatalogChange.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports